export default function CtaSection() {
  return (
    <section id="cta" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4e36859ce7a65cda85d8db5a8f2f8785.jpg"
          alt="RidgeCap GC Roofing Work"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d0d1a]/95 via-[#0d0d1a]/80 to-[#0d0d1a]/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-start gap-16">
          {/* Left Content */}
          <div className="flex-1 text-white">
            <div className="inline-flex items-center gap-2 bg-[#f97316]/20 text-[#f97316] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
              <i className="ri-gift-line"></i>
              Get The Most for Your Insurance Payout
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black leading-tight mb-6">
              Stop Leaving Money on the Table. <span className="text-[#f97316]">We&apos;ll Get It Back for You.</span>
            </h2>
            <p className="text-white/70 text-base leading-relaxed mb-8 max-w-lg">
              A free inspection and claim review costs you nothing. In 30 minutes, we&apos;ll show you exactly how much depreciation you&apos;re entitled to, what your estimate is missing, and how RidgeCap GC can help maximize your insurance payout.
            </p>

            <div className="space-y-4 mb-8">
              {[
                { icon: "ri-checkbox-circle-fill", text: "Free roof inspection & photo documentation" },
                { icon: "ri-checkbox-circle-fill", text: "Full insurance estimate review — line by line" },
                { icon: "ri-checkbox-circle-fill", text: "Depreciation holdback calculation" },
                { icon: "ri-checkbox-circle-fill", text: "No obligation, no pressure" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#f97316] text-lg`}></i>
                  </div>
                  <span className="text-white/80 text-sm">{item.text}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#f97316] rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-white text-lg"></i>
                </div>
                <div>
                  <div className="text-white/50 text-xs">NWA Office</div>
                  <a href="tel:4793964040" className="text-white font-bold text-base cursor-pointer hover:text-[#f97316] transition-colors">
                    479-396-4040
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#f97316] rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-white text-lg"></i>
                </div>
                <div>
                  <div className="text-white/50 text-xs">DFW Office</div>
                  <a href="tel:2149458899" className="text-white font-bold text-base cursor-pointer hover:text-[#f97316] transition-colors">
                    214-945-8899
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right — Calendly */}
          <div className="flex-shrink-0 w-full lg:w-[520px]">
            <div className="bg-white rounded-2xl overflow-hidden border border-white/10">
              <div className="bg-[#f97316] px-6 py-4">
                <h3 className="text-white font-black text-lg">Schedule Your Free Estimate Review and Inspection</h3>
                <p className="text-white/80 text-sm mt-0.5">Pick a time that works for you — no obligation</p>
              </div>
              <iframe
                src="https://calendly.com/ridgecapgc/ridgecap-free-no-obligation-inspection-and-estimate?embed_domain=ridgecapgc.com&embed_type=Inline&hide_gdpr_banner=1"
                width="100%"
                height="700"
                frameBorder="0"
                title="Schedule a Free Inspection with RidgeCap GC"
                style={{ display: "block" }}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
